/**
 * Removes menu nodes whose model is in hiddenModels (recursive).
 * Used to hide virtual routes from the sidebar while keeping them for breadcrumb.
 */
export function filterMenuByModels(items, hiddenModels) {
	if (!items || !Array.isArray(items)) {
		return [];
	}
	const hidden = new Set(hiddenModels || []);
	return items
		.filter((item) => !hidden.has(item.model))
		.map((item) => ({
			...item,
			children: filterMenuByModels(item.children || [], hiddenModels)
		}));
}
